import createEscaper from './_createEscaper.js';
import unescapeMap from './_unescapeMap.js';

// Function for unescaping strings from HTML interpolation.
export default createEscaper(unescapeMap);



//////////////////
// WEBPACK FOOTER
// /home/ensapb/site/web/app/themes/ensapb/node_modules/underscore/modules/unescape.js
// module id = 130
// module chunks = 0